/*@flow*/
import t from 'tcomb';

export default t.subtype(t.Array, x => x && x.length === 0, 'EmptyArray');
